import React from "react";
import { useState, useEffect, useRef } from "react";
import "./ExtraSection.css";
import Waves from "../blocks/Backgrounds/Waves/Waves";
import { FaTwitter, FaInstagram, FaYoutube, FaTwitch, FaGithub, FaLinkedin, FaDiscord } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useTranslation } from "../i18n";
import { renderBrandText } from "../utils/brandText";

function ExtraSection() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    if (progressCircle.current && progressContent.current) {
        progressCircle.current.style.setProperty('--progress', 1 - progress);
        progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    }
  };

  useEffect(() => {
      const checkMobile = () => {
          setIsMobile(window.innerWidth <= 768);
      };

      checkMobile(); // Verifica al cargar

      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      {isMobile ? (
        <>
          <section className="extra-section">
            {/* Fondo animado con Waves */}
            <div className="extra-waves">  {/* Cambiado de waves-section a extra-waves */}
              <Waves 
                  lineColor="#97b79e" 
                  backgroundColor="transparent" 
                  waveSpeedX={0.02}
                  waveSpeedY={0.005}
                  waveAmpX={25}
                  waveAmpY={10}
                  xGap={12}
                  yGap={20}
                  className="custom-waves"
              />
            </div>
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={2}
              pagination={true}
              autoplay={{ delay: 3000, disableOnInteraction: false }} // 🔥 Autoplay cada 3 segundos
              loop={true} // 🔥 Hace que los slides se repitan en un bucle
              style={{ width: "100%", maxWidth: "1200px", height: "auto" }}
              onAutoplayTimeLeft={onAutoplayTimeLeft}
              className="info-swiper"
            >
              <SwiperSlide>
                <div className="extra-column about">
                  <h3>{t("extra.aboutTitle")}</h3>
                  <p>{t("extra.aboutTextShort")}</p>
                  <p>{renderBrandText(t("extra.aboutText2"))}</p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="extra-column latest-posts">
                  <h3>{t("extra.latestPosts")}</h3>
                  <ul>
                    <li><a href="/blog">{t("extra.cypress")}</a></li>
                    <li><a href="/blog">{t("extra.cucumber")}</a></li>
                    <li><a href="/blog">{t("extra.appium")}</a></li>
                  </ul>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="extra-column latest-projects">
                  <h3>{t("extra.projects")}</h3>
                  <ul>
                    <li>ChefMate</li>
                    <li><a href="/"><span className="theqahub-font">{"</"}TheQAHub{">"}</span></a></li>
                    <li>
                      <a href="https://academy.theqahub.es" target="_blank" rel="noreferrer">
                        <span className="academy-wordmark">
                          <span className="academy-wordmark-hub theqahub-font" translate="no">TheQAHub</span>
                          <span className="academy-wordmark-academy">Academy</span>
                        </span>
                      </a>
                    </li>
                    <li>TestLab</li>
                    <li>Subtrack</li>
                  </ul>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="extra-column useful-links">
                  <h3>{t("extra.usefulLinksTitle")}</h3>
                  <ul>
                    <li><a href="/sobre-mi">{t("nav.about")}</a></li>
                    <li><a href="/contacto">{t("nav.contact")}</a></li>
                    <li><a href="/aprende">{t("extra.learnQa")}</a></li>
                    <li><a href="/cookies-policy">{t("cookies.link")}</a></li>
                    <li><a href="/privacy-policy">{t("extra.privacy")}</a></li>
                  </ul>
                </div>
              </SwiperSlide>
            </Swiper>
          </section>
        </>
      ) : (
        <>
          <section className="extra-section">
            {/* Fondo animado con Waves */}
            <div className="extra-waves">  {/* Cambiado de waves-section a extra-waves */}
              <Waves 
                  lineColor="#97b79e" 
                  backgroundColor="transparent" 
                  waveSpeedX={0.02}
                  waveSpeedY={0.005}
                  waveAmpX={25}
                  waveAmpY={10}
                  xGap={12}
                  yGap={20}
                  className="custom-waves"
              />
            </div>

            <div className="extra-content">
              <div className="extra-container">
                <div className="extra-column about">
                  <h3>{t("extra.aboutTitle")}</h3>
                  <p>{t("extra.aboutText")}</p>
                  <p>{renderBrandText(t("extra.aboutText2"))}</p>
                </div>

                <div className="extra-column latest-posts">
                  <h3>{t("extra.latestPosts")}</h3>
                  <ul>
                    <li><a href="/blog">{t("extra.cypress")}</a></li>
                    <li><a href="/blog">{t("extra.cucumber")}</a></li>
                    <li><a href="/blog">{t("extra.appium")}</a></li>
                  </ul>
                </div>

                <div className="extra-column latest-projects">
                  <h3>{t("extra.projects")}</h3>
                  <ul>
                    <li>ChefMate</li>
                    <li><a href="/"><span className="theqahub-font">{"</"}TheQAHub{">"}</span></a></li>
                    <li>
                      <a href="https://academy.theqahub.es" target="_blank" rel="noreferrer">
                        <span className="academy-wordmark">
                          <span className="academy-wordmark-hub theqahub-font" translate="no">TheQAHub</span>
                          <span className="academy-wordmark-academy">Academy</span>
                        </span>
                      </a>
                    </li>
                    <li>TestLab</li>
                    <li>Subtrack</li>
                  </ul>
                </div>

                <div className="extra-column useful-links">
                  <h3>{t("extra.usefulLinksTitle")}</h3>
                  <ul>
                    <li><a href="/sobre-mi">{t("nav.about")}</a></li>
                    <li><a href="/contacto">{t("nav.contact")}</a></li>
                    <li><a href="/aprende">{t("extra.learnQa")}</a></li>
                    <li><a href="/cookies-policy">{t("cookies.link")}</a></li>
                    <li><a href="/privacy-policy">{t("extra.privacy")}</a></li>
                  </ul>
                </div>
              </div>

              <div className="extra-footer">
                <div className="social-icons">
                  <a href="https://twitter.com/theqahub"><FaTwitter /></a>
                  <a href="https://www.instagram.com/theqahub_es/"><FaInstagram /></a>
                  <a href="https://www.youtube.com/@theqahub_es"><FaYoutube /></a>
                  <a href="https://www.twitch.tv/theqahub"><FaTwitch /></a>
                  <a href="https://github.com/theqahub"><FaGithub /></a>
                  <a href="https://www.linkedin.com/in/diegosanchezmartin/"><FaLinkedin /></a>
                  <a href="https://discord.gg/Yt4hNswy"><FaDiscord /></a>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}

export default ExtraSection;
